import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, CircularProgress, Grid, Paper, Tab, Tabs, Typography } from '@material-ui/core';

import { MobileButton, MobileRegularPage, TabPanel } from '../../../components';
import MessageCard from './MessageCard.component';

import { a11yProps } from "../../../services/a11y.service";

import useStyles from './Home.style';
import Cookies from 'universal-cookie';


const cookies = new Cookies();


const Home = () => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const [selectedTab, setSelectedTab] = useState("one");
    const [allMessages, setAllMessages] = useState([]);
    const [newMessages, setNewMessages] = useState([]);
    const [read, setRead] = useState(false);

    useEffect(() => {
        const getAllMessages = async () => {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_MESSAGE}/mymessages`, {
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });
            let json = await response.json();
            if (!response) throw new Error(json.message);

            setAllMessages(json);
        };

        const getMyNewMessages = async () => {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_MESSAGE}/mynewmessages`, {
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });
            let json = await response.json();
            if (!response) throw new Error(json.message);

            setNewMessages(json);
        };

        const getMessages = async () => {
            try {
                await getMyNewMessages();
                await getAllMessages();
            } catch (error) {
                console.log(error);
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        getMessages();
    }, []);

    useEffect(() => {
        const setUserLastMessageReadTimestamp = async () => {
            try {
                let response = fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_USER}/updateMyUserLastMessageRead`, {
                    method: 'post',
                    headers: {
                        'X-ACCESS-TOKEN': cookies.get('token')
                    }
                });
                if (!response) return;

                setRead(true);
            } catch (error) {
                console.log(error);
            };
        };

        setTimeout(() => setUserLastMessageReadTimestamp(), 3000);
    }, []);

    const handleTabChange = (e, newSelectedTab) => {
        setSelectedTab(newSelectedTab);
    }

    return (
        <MobileRegularPage>
            <Paper className={classes.header}>
                <Paper className={classes.title} square>
                    <Typography variant="h4">My Messages</Typography>
                </Paper>
                <Tabs
                    value={selectedTab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleTabChange}
                    aria-label="messages tabs"
                    variant="fullWidth"
                    className={classes.tab}
                >
                    <Tab label="New Messages" value="one" {...a11yProps('one')} />
                    <Tab label="All Messages" value="two" {...a11yProps('two')} />
                </Tabs>
            </Paper>
            <Box className={classes.tabPanelsContainer}>
                {error && <p>{error}</p>}
                {loading &&
                    <CircularProgress />
                }
                {!loading &&
                    <>
                        <TabPanel value={selectedTab} index="one" className={classes.tabPanel}>
                            <Grid container spacing={1}>
                                {newMessages.length === 0 &&
                                    <Typography className={classes.noMessageCard}>No new messages for now</Typography>
                                }
                                {newMessages.map(message =>
                                    <Grid item xs={12} key={message._id}>
                                        <MessageCard
                                            author={message.author}
                                            date={moment(message.createdAt).format('MMM D')}
                                            title={message.title}
                                            message={message.body}
                                            read={read}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </TabPanel>
                        <TabPanel value={selectedTab} index="two" className={classes.tabPanel}>
                            <Grid container spacing={1}>
                                {allMessages.map(message =>
                                    <Grid item xs={12} key={message._id}>
                                        <MessageCard
                                            author={message.author}
                                            date={moment(message.createdAt).format('MMM D')}
                                            title={message.title}
                                            message={message.body}
                                            read={true}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </TabPanel>
                    </>
                }
            </Box>
            <Paper className={classes.footer}>
                <MobileButton
                    label={t('common.form.button.back')}
                    component={RouterLink}
                    to="/app/dashboard"
                />
            </Paper>
        </MobileRegularPage>
    );
};

export default Home;